import { OrderStatus } from '@/interfaces/order.interface';

const DASHBOARD_ALLOWED_ORDER_STATUSES = new Set<string>([
  OrderStatus.ACTIVE,
  OrderStatus.ACTIVATING,
  OrderStatus.SUSPENDED,
  OrderStatus.SUSPENDING,
]);

const SELECTABLE_ORDER_STATUSES = new Set<string>([
  ...DASHBOARD_ALLOWED_ORDER_STATUSES,
  OrderStatus.PENDING,
]);

export function isDashboardAllowedOrderStatus(status?: string | null): boolean {
  if (!status) return false;
  return DASHBOARD_ALLOWED_ORDER_STATUSES.has(status);
}

export function isSelectableOrderStatus(status?: string | null): boolean {
  if (!status) return false;
  return SELECTABLE_ORDER_STATUSES.has(status);
}
